import React, { Fragment } from "react";

import "./Founding.css";

const Founding = () => {
  return (
    <div className="founding-container1 thq-section-padding">
      <Fragment>
        <span className="hero8-text11">
          <span>
            Coin Basis was born out of a real-world challenge faced by Ethan
            Friman, a cryptocurrency enthusiast and early adopter. During the
            preparation for his 2024 taxes, Ethan encountered the complexity of
            calculating the cost basis for hundreds of cryptocurrency
            transactions across multiple currencies. Managing these transactions
            manually in Excel and attempting to calculate the cost basis using
            FIFO (First In, First Out) proved to be an overwhelming and nearly
            impossible task.
          </span>
          <br></br>
          <br></br>
          <span>
            When searching for solutions, Ethan discovered that existing tools
            were either prohibitively expensive or lacked user-friendly
            interfaces. Realizing the need for a better solution, he envisioned
            a platform that would simplify cost basis calculations while
            remaining accessible and affordable for everyone.
          </span>
          <br></br>
          <br></br>
          <span>
            To bring this vision to life, Ethan partnered with his brother, Seth
            Friman, a skilled developer and data scientist. With a shared
            passion for creating practical and impactful products, the brothers
            set to work. Ethan contributed his deep knowledge of cryptocurrency,
            gained through seven years in the space and experience with crypto
            startups, while Seth used his expertise in software development and
            economics to develop and fine-tune the algorithm that powers Coin
            Basis. Together, they designed a user-friendly interface that
            ensures the software is intuitive and accessible to users of all
            experience levels.
          </span>
          <br></br>
          <br></br>
          <span>
            The result was Coin Basis, a platform dedicated to helping
            individuals and businesses effortlessly calculate their cost basis
            for cryptocurrency transactions and generate accurate reports for
            tax preparation. The brothers are now preparing are excited to be
            able to release the platform in time for the 2024 tax season.
          </span>
          <br></br>
          <br></br>
          <span>
            With a mission to provide precision, transparency, and
            affordability, Coin Basis aims to empower users to navigate the
            complexities of crypto tax preparation with confidence.
          </span>
        </span>
      </Fragment>
    </div>
  );
};

export default Founding;
